import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-privacy-log-action',
  templateUrl: './privacy-log-action.component.html',
  styleUrls: ['./privacy-log-action.component.css']
})
export class PrivacyLogActionComponent implements OnInit {

  @Input()
  action: any;

  constructor() { }

  ngOnInit(): void {
  }

  getActionDescription(action: string) {
    switch (action) {
      case 'PRIVACY_LANDING_PAGE_OPENED': {
        return 'Landing page aperta';
      }
      case 'PRIVACY_OPTION_APPLIED': {
        return 'Consensi raccolti';
      }
      case 'SIGNED_MANUALLY': {
        return 'Firma tramite app';
      }
      case 'EMAIL_ERROR': {
        return 'Errore, email non inviata';
      }
      case 'EMAIL_SENT':{
        return 'Email inviata'
      }
    }
  }

  getIcon(action){
    switch (action) {
      case 'PRIVACY_LANDING_PAGE_OPENED': {
        return 'eye-outline';
      }
      case 'PRIVACY_OPTION_APPLIED': {
        return 'checkmark-circle-2-outline';
      }
      case 'SIGNED_MANUALLY': {
        return 'smartphone-outline';
      }
      case 'EMAIL_ERROR': {
        return 'close-circle-outline';
      }
      case 'EMAIL_SENT':{
        return 'email-outline';
      }
    }
  }

}
